import { Injectable } from '@angular/core';
import { ProductsConfig } from '@workflow/class/config.type';
import { WorkflowWidgetInitArgs } from '@workflow/widget-context.type';
import { WorkflowWidgetConfigAndRouteService } from '@workflow/widget/workflow-widget-config-route.service';

/**
 * Initializer service for getting external workflow config from DB or any other sources
 */
@Injectable({
  providedIn: 'root'
})
export class InitializeWorkflowWidgetService {
  constructor(private readonly wwr: WorkflowWidgetConfigAndRouteService) {}

  /**
   * The method will initialize workflow widget with initilizer object.
   *
   * @param configURL - the worfkflow config url passed to set in WW initilizer object.
   *
   * @returns A promise that return after wiget config has been successfully initialized.
   */
  public initWorkflowWidget(configURL: string): Promise<boolean> {
    const widgetInitArgs: WorkflowWidgetInitArgs = this.getWidgetInitArgs(configURL);
    return this.wwr.loadConfigsAddRoutes(widgetInitArgs);
  }

  /**
   * The method will create and return workflow widget initilizer object.
   *
   * @param configURL - the worfkflow config url passed to set in WW initilizer object.
   *
   * @returns the WW initilizer object
   *
   */
  private getWidgetInitArgs(configURL: string): WorkflowWidgetInitArgs {
    return {
      products: ['oao', 'ola'],
      configApi: configURL,
      // bundleApi: 'https://dev1-api.cudirect.com/cpapi', // This is optional, if not set, it will read from StorageInfo
      routePrefix: 'app',
      includeRouteFlowIds: [],
      customConfig: {
        loginInfo: {
          hasRegistration: true,
          registrationUrl: 'user/light-registration'
        },
        pagesInfo: {
          skipEligibility: false, // set value here.
          skipReferral: false
        }
      }
    };
  }

  /**
   * The method will set the config data to the WorkflowWidget and RouteService.
   *
   * @param configURL - the worfkflow config url passed to set in workflow widget initilizer object.
   * @param data - Products config data has been passed to set in workflow widget
   */
  public setConfigData(configURL: string, data: ProductsConfig): void {
    const widgetInitArgs: WorkflowWidgetInitArgs = this.getWidgetInitArgs(configURL);
    this.wwr.configData(widgetInitArgs, data);
  }
}
